import * as storage from '@inqool/uas-web-core/es/utils/storage';
import base64 from 'base-64';
import utf8 from 'utf8';
import { isEmpty } from 'lodash';
import decode from 'jwt-decode';
import { fetch } from '@utils/utils';
import {
  clearPasswordChangeRequired,
  getPasswordChangeState,
  setPasswordChangeRequired
} from '@modules/login/_passwordChange';

const getPermissions = async emplyeeId => {
  try {
    const response = await fetch(`/metropolis/api/users/${emplyeeId}/roles`, { method: 'GET' });
    const roles = await response.json();

    const permissionsArray = roles.map(({ permissions: rolePermisssions }) => rolePermisssions);

    const permissions = [].concat.apply([], permissionsArray);

    return Array.from(new Set(permissions));
  } catch (err) {
    return [];
  }
};

export const kerberosSignIn = ({ addError, addSuccess }) => async (passwordChangeExtensionEnabled = false) => {
  try {
    const response = await fetch('/metropolis/api/kerberos/login', {
      checkToken: () => false,
      method: 'POST'
    });
    if (response.ok && !isEmpty(response.headers.get('Bearer'))) {
      const token = storage.get('token');
      const { sub, id } = decode(token);
      const permissions = await getPermissions(id);
      const passwordChangeState = getPasswordChangeState(response.headers);
      storage.put('user', sub);
      storage.put('id', id);
      storage.put('permissions', JSON.stringify(permissions));
      if (passwordChangeExtensionEnabled && passwordChangeState.required) {
        setPasswordChangeRequired(passwordChangeState.minLength);
      } else {
        clearPasswordChangeRequired();
      }
      window.location.replace('/');
      addSuccess('Přihlášení proběhlo úspěšne');
      return true;
    }
    addError('Přihlášení přes Kerberos nebylo úspěšné.');
    return false;
  } catch ({ message }) {
    addError('Přihlášení přes Kerberos nebylo úspěšné.');
    return false;
  }
};

export const signIn = ({ addSuccess, addError }) => async (
  username,
  password,
  url = '/metropolis/api/ldap/login',
  passwordChangeExtensionEnabled = false
) => {
  try {
    const response = await fetch(url, {
      checkToken: () => false,
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Basic ${utf8.encode(base64.encode(`${username}:${password}`))}`
      })
    });
    if (response.ok && !isEmpty(response.headers.get('Bearer'))) {
      addSuccess('Přihlášení proběhlo úspěšne');
      const token = storage.get('token');
      const { sub, id } = decode(token);
      const permissions = await getPermissions(id);
      const passwordChangeState = getPasswordChangeState(response.headers);
      storage.put('user', sub);
      storage.put('id', id);
      storage.put('permissions', JSON.stringify(permissions));
      if (passwordChangeExtensionEnabled && passwordChangeState.required) {
        setPasswordChangeRequired(passwordChangeState.minLength);
        addError('Pro pokračování je nutné změnit heslo.');
      } else {
        clearPasswordChangeRequired();
      }
      return true;
    }
    addError('Uživatelské jméno nebo heslo není správné.');
    return false;
  } catch ({ message }) {
    addError(message);
    return false;
  }
};

const logOut = ({ addError }) => async () => {
  try {
    const response = await fetch('/metropolis/api/hr/employees/log-out', {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    });
    if (response.ok) {
      clearPasswordChangeRequired();
      return true;
    } else {
      addError('Odhlášení nebylo úspěšné');
      return false;
    }
  } catch ({ message }) {
    addError('Odhlášení nebylo úspěšné' + message);
    return false;
  }
};

export const signOut = ({ addError, addSuccess }) => async history => {
  await logOut({ addError })();
  storage.remove('token');
  storage.remove('gistoken');
  storage.remove('user');
  storage.remove('id');
  storage.remove('permissions');
  storage.remove('extensions');
  clearPasswordChangeRequired();
  history.push('/login');
  window.location.reload(true);
  addSuccess('Odhlášení proběhlo úspěšne');
};

export const changeRequiredPassword = ({ addError, addSuccess }) => async (payload: any): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/employees/change-password`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ password: payload.password, passwordAgain: payload.passwordConfirm })
    });
    clearPasswordChangeRequired();
    addSuccess('Heslo bylo úspěšně změněno.');
    return response;
  } catch (err) {
    addError('Změna hesla se nepovedla.');
    return null;
  }
};

export const isLoggedIn = () => {
  const token = storage.get('token');
  if (token && token !== 'null') {
    const decoded = decode(token);
    return decoded != null;
  }
  return false;
};

// const renewAction = async history => {
//   const token = storage.get('token');

//   // in case, somebody changed the token in storage
//   if (!isEmpty(token) && token !== 'null') {
//     try {
//       await fetch('/metropolis/api/login', { method: 'POST' });
//       return;
//     } catch (e) {
//       // exception is catched and signOut is called
//     }
//   }

//   signOut(history);
// };

// export const renewToken = history => {
//   renewAction(history);
//   return setInterval(() => renewAction(history), 60 * 1000); // 60 s interval refresh
// };

// export const hasKpiOverrulingRole = () => {
//   const token = storage.get('token');

//   if (token && token !== 'null') {
//     const decoded = decode(token);

//     const authorities = get(decoded, 'authorities');

//     return authorities && authorities.includes('ROLE_KPI_OVERRULING');
//   } else {
//     return false;
//   }
// };



// WEBPACK FOOTER //
// ./src/modules/login/_loginActions.ts